import React from 'react';

const CheckIcon = () => (
  <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.5322 0.823164L22.3554 0.646517L22.1787 0.823212L8.3688 14.6313L2.81983 9.0817L2.6429 8.90474L2.46611 9.08184L0.823065 10.7278L0.646602 10.9046L0.823227 11.0812L8.19201 18.4497L8.36878 18.6265L8.54555 18.4498L24.1768 2.82025L24.3536 2.64341L24.1767 2.46662L22.5322 0.823164Z" fill="#002347" stroke="#002347" strokeWidth="0.5" />
  </svg>
);

export default CheckIcon;
